export const dateRangeFilterOptions = [
    { value: "lost.createdAt", label: "Reported Date" },
    { value: "lost.lostDate", label: "Lost Date" },
];

export const reportFilterOptions = [
    { value: "lost.trackingId", label: "Claim Number" },
    { value: "user.email", label: "Email" },
    { value: "user.firstName", label: "First Name" },
    { value: "user.lastName", label: "Last Name" },
    { value: "caseManager.id", label: "Case Manager" },
    { value: "user.phone", label: "Phone Number" },
    { value: "lost.bookingNumber", label: "Booking Number" },
    { value: "lost.itemDescription", label: "Item Description" },
    { value: "category.name", label: "Category" },
    { value: "user.countryCode", label: "Country Code" },
];


export const foundReportFilterOptions = [
    { value: "found.itemNumber", label: "Item Number" },
    { value: "caseManager.firstName", label: "Case Manager" },
    { value: "found.itemDescription", label: "Item Description" },
    { value: "found.remarks", label: "Item Remarks" },
    { value: "found.createdAt", label: "Created At" },
    { value: "ship.name", label: "Ship" },
    { value: "category.name", label: "Category" },
    { value: "subCategory.name", label: "Item Type" },
    { value: "location.name", label: "Location" }
];


export const foundDateRangeFilterOptions = [
    { value: "found.createdAt", label: "Reported Date" },
    { value: "found.foundDate", label: "Found Date" },
    { value: "found.offloadDate", label: "Offload Date" },
];

export const unAssignCaseMangerOptionValue = "unAssign";
